export default __webpack_public_path__ + "static/media/subaru.1c6e39a9.svg";